import Vue from "vue";
import axios from "axios";
const apiCache = new Map();

export default {
    envPath: function() {
        // if (process.env.NODE_ENV === "development") {
        //     return "/api"; // 测试环境加上前缀，为了config/index.js里的测试环境代理proxyTable配置
        // }
        return "";
    },
    /**
     * req Command命令提交调用
     * @param {*} url
     * @param {*} data        要提交的参数
     */
    req: function(
        url,
        data,
        pSuccessCallback,
        method = "post",
        loadingFlag = true,
        ctype = "payload"
    ) {
        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        if (ctype == "payload") {
            headers["Content-Type"] = "application/json; charset=utf-8";
        } else if (ctype == "formData") {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
            let tmp = data;
            const formData = new FormData();
            for (const key in tmp) {
                if (tmp.hasOwnProperty(key)) {
                    if (tmp[key]) {
                        if (tmp[key].constructor === Array) {
                            if (tmp[key][0]) {
                                if (tmp[key][0].constructor === Object) {
                                    formData.append(
                                        key,
                                        JSON.stringify(tmp[key])
                                    );
                                } else {
                                    tmp[key].forEach((item, index) => {
                                        formData.append(
                                            key + `[${index}]`,
                                            item
                                        );
                                    });
                                }
                            } else {
                                formData.append(key + "[]", "");
                            }
                        } else if (tmp[key].constructor === Object) {
                            formData.append(key, JSON.stringify(tmp[key]));
                        } else {
                            formData.append(key, tmp[key]);
                        }
                    } else {
                        if (tmp[key] === 0) {
                            formData.append(key, 0);
                        } else {
                            formData.append(key, "");
                        }
                    }
                }
            }
            data = formData;
        }

        axios({
            url: url,
            method: method,
            data: data,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    if (
                        response.data &&
                        response.data.errorCode &&
                        response.data.errorCode == "401"
                    ) {
                        _this.$message({
                            showClose: true,
                            message: "登录过期，请重新登录",
                            type: "warning"
                        });
                        sessionStorage.clear();
                        _this.$router.push("/login");
                    } else if (pSuccessCallback != undefined) {
                        let token = response.headers["hwt-token"];
                        if (token) {
                            sessionStorage.setItem("hwt-token", token);
                        }

                        pSuccessCallback.apply(_this, [response.data]);
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "Error：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "Connect error[" + response.status + "]",
                        type: "warning"
                    });
                }
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                // console.log(err.response.status);
                if (loadingFlag) {
                    loading.close();
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });
    },
    /**
     * req Command命令提交调用
     * @param {*} url
     * @param {*} data        要提交的参数
     */
    reqAsy: async function({
        url,
        data,
        method = "post",
        loadingFlag = true,
        ctype = "payload"
    }) {
        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        if (ctype == "payload") {
            headers["Content-Type"] = "application/json; charset=utf-8";
        } else if (ctype == "formData") {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
            let tmp = data;
            const formData = new FormData();
            for (const key in tmp) {
                if (tmp.hasOwnProperty(key)) {
                    if (tmp[key]) {
                        if (tmp[key].constructor === Array) {
                            if (tmp[key][0]) {
                                if (tmp[key][0].constructor === Object) {
                                    formData.append(
                                        key,
                                        JSON.stringify(tmp[key])
                                    );
                                } else {
                                    tmp[key].forEach((item, index) => {
                                        formData.append(
                                            key + `[${index}]`,
                                            item
                                        );
                                    });
                                }
                            } else {
                                formData.append(key + "[]", "");
                            }
                        } else if (tmp[key].constructor === Object) {
                            formData.append(key, JSON.stringify(tmp[key]));
                        } else {
                            formData.append(key, tmp[key]);
                        }
                    } else {
                        if (tmp[key] === 0) {
                            formData.append(key, 0);
                        } else {
                            formData.append(key, "");
                        }
                    }
                }
            }
            data = formData;
        }

        return axios({
            url: url,
            method: method,
            data: data,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    if (
                        response.data &&
                        response.data.errorCode &&
                        response.data.errorCode == "401"
                    ) {
                        _this.$message({
                            showClose: true,
                            message: "登录过期，请重新登录",
                            type: "warning"
                        });
                        sessionStorage.clear();
                        _this.$router.push("/login");
                    } else {
                        let token = response.headers["hwt-token"];
                        if (token) {
                            sessionStorage.setItem("hwt-token", token);
                        }

                        // pSuccessCallback.apply(_this, [response.data]);
                        return response.data;
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "Error：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "Connect error[" + response.status + "]",
                        type: "warning"
                    });
                }
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                // console.log(err.response.status);
                if (loadingFlag) {
                    loading.close();
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });
    },
    /**
     * req Command命令提交调用
     * @param {*} url
     * @param {*} data        要提交的参数
     */
    reqCache: function(
        url,
        data,
        method = "post",
        loadingFlag = true,
        ctype = "payload"
    ) {
        let cacheKey = data.cacheKey;
        if (cacheKey && apiCache.has(cacheKey)) {
            return apiCache.get(cacheKey);
        }

        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        if (ctype == "payload") {
            headers["Content-Type"] = "application/json; charset=utf-8";
        } else if (ctype == "formData") {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
            let tmp = data;
            const formData = new FormData();
            for (const key in tmp) {
                if (tmp.hasOwnProperty(key)) {
                    if (tmp[key]) {
                        if (tmp[key].constructor === Array) {
                            if (tmp[key][0]) {
                                if (tmp[key][0].constructor === Object) {
                                    formData.append(
                                        key,
                                        JSON.stringify(tmp[key])
                                    );
                                } else {
                                    tmp[key].forEach((item, index) => {
                                        formData.append(
                                            key + `[${index}]`,
                                            item
                                        );
                                    });
                                }
                            } else {
                                formData.append(key + "[]", "");
                            }
                        } else if (tmp[key].constructor === Object) {
                            formData.append(key, JSON.stringify(tmp[key]));
                        } else {
                            formData.append(key, tmp[key]);
                        }
                    } else {
                        if (tmp[key] === 0) {
                            formData.append(key, 0);
                        } else {
                            formData.append(key, "");
                        }
                    }
                }
            }
            data = formData;
        }

        const promise = axios({
            url: url,
            method: method,
            data: data,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    if (
                        response.data &&
                        response.data.errorCode &&
                        response.data.errorCode == "401"
                    ) {
                        _this.$message({
                            showClose: true,
                            message: "登录过期，请重新登录",
                            type: "warning"
                        });
                        sessionStorage.clear();
                        _this.$router.push("/login");
                    } else {
                        let token = response.headers["hwt-token"];
                        if (token) {
                            sessionStorage.setItem("hwt-token", token);
                        }

                        // pSuccessCallback.apply(_this, [response.data]);
                        apiCache.set(cacheKey, response.data);
                        return response.data;
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "Error：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "Connect error[" + response.status + "]",
                        type: "warning"
                    });
                }
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                // console.log(err.response.status);
                if (loadingFlag) {
                    loading.close();
                }

                if (cacheKey) {
                    apiCache.delete(cacheKey); // 请求失败时移除缓存
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });

        // 将 Promise 临时存入缓存（避免重复请求）
        apiCache.set(cacheKey, promise);
        return promise;
    },
    /**
     * 导出 Command命令提交调用
     * @param {*} url
     * @param {*} pParameter        要提交的参数
     * @param {*} pSuccessCallback  成功时的回调
     */
    export: function(
        url,
        pParameter,
        pSuccessCallback,
        method = "post",
        loadingFlag = true
    ) {
        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        axios({
            url: url,
            method: method,
            responseType: "blob",
            data: pParameter,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    console.log(response);
                    if (response.headers["content-disposition"] != null) {
                        let fileName = window.decodeURI(
                            response.headers["content-disposition"].split(
                                "="
                            )[1]
                        );
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(
                            new Blob([response.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            })
                        );
                        link.target = "_blank";
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else if (
                        response.headers["content-type"] ==
                        "application/json;charset=UTF-8"
                    ) {
                        console.log(1465456165);
                        let reader = new FileReader(); // 创建读取文件对象
                        reader.readAsText(new Blob([response.data]), "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
                        reader.addEventListener("loadend", function() {
                            //
                            let res = JSON.parse(reader.result); // 返回的数据
                            response.data = res;
                            if (!res.success) {
                                _this
                                    .$alert(res.message, "提示", {
                                        confirmButtonText: "关闭",
                                        type: "warning"
                                    })
                                    .then(() => {})
                                    .catch(() => {});
                            }

                            //console.log(res,'返回结果数据') // { name: "小明" }
                        });
                        console.log(response);
                        pSuccessCallback.apply(_this, response.data);
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "请求异常：" + response.status,
                        type: "warning"
                    });
                    // sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "通讯异常[" + response.status + "]",
                        type: "warning"
                    });
                }
                pSuccessCallback.apply(_this);
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                if (loadingFlag) {
                    loading.close();
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });
    },
    // 暂未使用
    downLoad: function(
        url,
        pParameter,
        pSuccessCallback,
        pErrorCallback,
        method = "post"
    ) {
        if (process.env.NODE_ENV === "development") {
            url = "/api" + url; // 测试环境加上前缀，为了config/index.js里的测试环境代理proxyTable配置
        }
        var _this = this;
        // const loading = this.$loading({
        //     lock: true,
        //     text: "Loading",
        //     spinner: "el-icon-loading",
        //     background: "rgba(0, 0, 0, 0.7)"
        // });

        let headers = {};
        if (sessionStorage.getItem("user-token")) {
            headers["hwt-token"] = sessionStorage.getItem("user-token");
        }

        this.$http({
            url: url,
            method: method,
            responseType: "blob",
            data: pParameter,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                // console.log(response);
                //loading.close();
                if (response.status == 200) {
                    console.log(response);
                    if (response.headers["content-disposition"] != null) {
                        let fileName = window.decodeURI(
                            response.headers["content-disposition"].split(
                                "="
                            )[1]
                        );
                        console.log(fileName);
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(
                            new Blob([response.data], {
                                type: "application/x-download"
                            })
                        );
                        link.target = "_blank";
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else if (
                        response.headers["content-type"] ==
                        "application/json;charset=UTF-8"
                    ) {
                        console.log(1465456165);
                        let reader = new FileReader(); // 创建读取文件对象
                        reader.readAsText(new Blob([response.data]), "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
                        reader.addEventListener("loadend", function() {
                            //
                            let res = JSON.parse(reader.result); // 返回的数据
                            response.data = res;
                            if (!res.success) {
                                _this
                                    .$alert(res.message, "提示", {
                                        confirmButtonText: "关闭",
                                        type: "warning"
                                    })
                                    .then(() => {})
                                    .catch(() => {});
                            }

                            //console.log(res,'返回结果数据') // { name: "小明" }
                        });
                        console.log(response);
                        pSuccessCallback.apply(_this, response.data);
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "请求异常：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "通讯异常[" + response.status + "]",
                        type: "warning"
                    });
                    if (pErrorCallback != undefined) {
                        pErrorCallback.apply(_this);
                    }
                }
                pSuccessCallback.apply(_this);
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                console.log(err.response.status);
                //loading.close();
                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
                if (pErrorCallback != undefined) {
                    pErrorCallback.apply(_this);
                }
            });
    },
    /**
     * 格式化金额（千分位）
     */
    fmoney: function(num) {
        //参数说明：num 要格式化的数字 n 保留小数位
        if (!num) {
            if (num === 0) {
                num = String(num.toFixed(2));
            } else {
                num = "";
            }
            return num;
        }

        if (typeof num == "string") {
            num = parseFloat(num);
        }

        num = String(num.toFixed(2));
        var re = /(-?\d+)(\d{3})/;
        while (re.test(num)) {
            num = num.replace(re, "$1,$2");
        }
        return num;
    },
    /**
     * 格式化时间
     */
    timeFormat: function(value, format) {
        if (!value) {
            return "";
        }
        let date = new Date(value);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let min = date.getMinutes();
        let s = date.getSeconds();
        let result = "";
        if (format == undefined) {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
                h < 10 ? "0" + h : h
            }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
        }
        if (format == "yyyy-mm-dd hh:mm") {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
                h < 10 ? "0" + h : h
            }:${min < 10 ? "0" + min : min}`;
        }
        if (format == "yyyy-mm-dd hh") {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
                h < 10 ? "0" + h : h
            }`;
        }
        if (format == "yyyy-mm-dd") {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
        }
        if (format == "yyyymmdd") {
            result = `${y}${m < 10 ? "0" + m : m}${d < 10 ? "0" + d : d}`;
        }
        if (format == "yyyy-mm") {
            result = `${y}-${m < 10 ? "0" + m : m}`;
        }
        if (format == "mm-dd") {
            result = `${mm < 10 ? "0" + mm : mm}:${ddmin < 10 ? "0" + dd : dd}`;
        }
        if (format == "dd hh:mm") {
            result = `${d < 10 ? "0" + d : d} ${h < 10 ? "0" + h : h}:${
                min < 10 ? "0" + min : min
            }`;
        }
        if (format == "hh:mm") {
            result = `${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
        }
        if (format == "yyyy") {
            result = `${y}`;
        }
        return result;
    },
    /**
     * 全局判断功能权限
     */
    funAuth: function(key) {
        return funAll.find(item => {
            return item.url == key;
        });
    },
    isImg: function(fileKey) {
        if (
            fileKey.endWith(".jpg") ||
            fileKey.endWith(".jpeg") ||
            fileKey.endWith(".png") ||
            fileKey.endWith(".JPG") ||
            fileKey.endWith(".JPEG") ||
            fileKey.endWith(".PNG")
        ) {
            return true;
        } else {
            return false;
        }
    },
    isDoc: function(fileKey) {
        if (
            fileKey.endWith(".pdf") ||
            fileKey.endWith(".doc") ||
            fileKey.endWith(".docx") ||
            fileKey.endWith(".PDF") ||
            fileKey.endWith(".DOC") ||
            fileKey.endWith(".DOCX")
        ) {
            return true;
        } else {
            return false;
        }
    },
    nameChar: function(val) {
        if (val) {
            let begin = 0,
                end = 0;
            if (val.length < 2) {
                begin = 0;
                end = 1;
            } else {
                begin = val.length - 2;
                end = val.length;
            }
            return val.substring(begin, end);
            // return val.substring(0, 1);
        } else {
            return "?";
        }
    },
    lastChar: function(val) {
        if (val) {
            let begin = val.length - 1;
            let end = val.length;
            return val.substring(begin, end);
            // return val.substring(0, 1);
        } else {
            return "?";
        }
    },
    nameToColor: function(name) {
        var str = "";
        for (var i = 0; i < name.length; i++) {
            str += parseInt(name[i].charCodeAt(0), 10).toString(16);
        }

        // 方案一
        // while (str.length < 8) {
        //     str += str;
        // }
        // str = str.slice(1, 7);

        // 方案二
        const colors = [
            "#F44336",
            "#E91E63",
            "#9C27B0",
            "#673AB7",
            "#3F51B5",
            "#2196F3",
            "#03A9F4",
            "#00BCD4",
            "#009688",
            "#4CAF50",
            "#8BC34A",
            "#CDDC39",
            "#FFEB3B",
            "#FFC107",
            "#FF9800",
            "#FF5722",
            "#795548",
            "#2E8B57",
            "#607D8B",
            "#333333",
            "#67C23A",
            "#E6A23C",
            "#F56C6C",
            "#000080",
            "#FF4081",
            "#9575CD",
            "#7986CB",
            "#64B5F6",
            "#4DD0E1",
            "#AED581",
            "#81C784",
            "#E57373"
        ];
        let t = 0;
        str.split("").forEach(function(n, i) {
            t += parseInt(n, 16);
        });
        t = t % 32;
        return colors[t];
    },
    makeTkey: function(prefix) {
        let n = 4;
        var str = "abcdefghijklmnopqrstuvwxyz0123456789";
        var result = "";
        for (var i = 0; i < n; i++) {
            result += str[parseInt(Math.random() * str.length)];
        }
        result = prefix + new Date().getTime() + result;
        // console.log(result);
        return result;
    },
    generateGradientColorCode: function(numColors, startColor, endColor) {
        let colors = [];
        for (let i = 0; i < numColors; i++) {
            let color = [];
            for (let j = 0; j < 3; j++) {
                let value =
                    (i / (numColors - 1)) * (endColor[j] - startColor[j]) +
                    startColor[j];
                color.push(Math.floor(value));
            }
            colors.push(`rgb(${color[0]}, ${color[1]}, ${color[2]})`);
        }
        return colors;
    },
    generateStageColors: function(numColors) {
        let startColor = [100, 194, 58];
        let midColor = [255, 220, 0];
        let endColor = [255, 40, 0];

        let step1 = numColors / 2;
        let colors1 = this.generateGradientColorCode(
            step1,
            startColor,
            midColor
        );

        let step2 = numColors - step1 + 1;
        let colors2 = this.generateGradientColorCode(step2, midColor, endColor);

        return colors1.concat(colors2.slice(1));
    },
    inputAmount: function(value) {
        return value
            .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
            .replace(/[^\d.]/g, "");
    },
    openPage: function(url) {
        window.open(url, "_blank");
    },
    downloadFile: function(url) {
        let fileName = url.substring(url.lastIndexOf("/") + 1);

        const element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", fileName);
        element.setAttribute("target", "_blank");

        // 触发点击
        document.body.appendChild(element);
        element.click();

        // 然后移除
        document.body.removeChild(element);
    },
    getStaffName: function(sex) {
        var random = Math.floor(Math.random() * 1000); // 使用 Math.random() 生成随机数
        var surname = [
            "赵",
            "钱",
            "孙",
            "李",
            "周",
            "吴",
            "郑",
            "王",
            "冯",
            "陈",
            "褚",
            "卫",
            "蒋",
            "沈",
            "韩",
            "杨",
            "朱",
            "秦",
            "尤",
            "许",
            "何",
            "吕",
            "施",
            "张",
            "孔",
            "曹",
            "严",
            "华",
            "金",
            "魏",
            "陶",
            "姜",
            "戚",
            "谢",
            "邹",
            "喻",
            "柏",
            "水",
            "窦",
            "章",
            "云",
            "苏",
            "潘",
            "葛",
            "奚",
            "范",
            "彭",
            "郎",
            "鲁",
            "韦",
            "昌",
            "马",
            "苗",
            "凤",
            "花",
            "方",
            "俞",
            "任",
            "袁",
            "柳",
            "佟",
            "鲍",
            "史",
            "唐",
            "费",
            "廉",
            "岑",
            "薛",
            "雷",
            "贺",
            "倪",
            "汤",
            "滕",
            "殷",
            "罗",
            "毕",
            "郝",
            "邬",
            "安",
            "常",
            "乐",
            "于",
            "时",
            "傅",
            "皮",
            "卞",
            "齐",
            "康",
            "伍",
            "余",
            "元",
            "卜",
            "顾",
            "孟",
            "平",
            "黄",
            "和",
            "穆",
            "萧",
            "尹",
            "姚",
            "邵",
            "湛",
            "汪",
            "祁",
            "毛",
            "禹",
            "狄",
            "米",
            "贝",
            "明",
            "臧",
            "计",
            "伏",
            "成",
            "戴",
            "谈",
            "宋",
            "茅",
            "庞",
            "熊",
            "纪",
            "舒",
            "屈",
            "项",
            "祝",
            "董",
            "梁",
            "杜",
            "阮",
            "蓝",
            "闵",
            "席",
            "季",
            "祖",
            "谭",
            "陆",
            "卢"
        ];
        var girl =
            "秀娟英华慧巧美娜静淑惠珠翠雅芝玉萍红娥玲芬芳燕彩春菊兰凤洁梅琳素云莲真环雪荣爱霞香月莺媛艳瑞凡佳嘉琼勤珍贞莉桂娣叶璧璐娅琦晶妍茜秋珊莎锦黛青倩婷姣婉娴瑾颖露瑶怡婵雁蓓纨仪荷丹蓉眉君琴蕊薇菁梦岚苑婕馨瑗琰韵融园艺咏卿聪澜纯毓悦昭冰爽琬茗羽希宁欣飘育滢馥筠柔竹霭凝晓欢霄枫芸菲寒伊亚宜可姬舒影荔枝思丽 ";
        var boy =
            "伟刚勇毅俊峰强军平保东文辉力明永健世广志义兴良海山仁波宁贵福生龙元全国胜学祥才发武新利清飞彬富顺信子杰涛昌成康星光天达安岩中茂进林有坚和彪博诚先敬震振壮会思群豪心邦承乐绍功松善厚庆磊民友裕河哲江超浩亮政谦亨奇固之轮翰朗伯宏言若鸣朋斌梁栋维启克伦翔旭鹏泽晨辰士以建家致树炎德行时泰盛雄琛钧冠策腾楠榕风航弘";

        var index = Math.floor(random % surname.length);
        var name = surname[index]; // 获得一个随机的姓氏

        if (sex === 0) {
            var j = Math.floor(Math.random() * (girl.length - 2));
            if (j % 2 === 0) {
                name = name + girl.substring(j, j + 2);
            } else {
                name = name + girl.substring(j, j + 1);
            }
        } else if (sex === 1) {
            var j = Math.floor(Math.random() * (boy.length - 2));
            if (j % 2 === 0) {
                name = name + boy.substring(j, j + 2);
            } else {
                name = name + boy.substring(j, j + 1);
            }
        }

        return name;
    },
    getRandomInt: function(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    },
    getRandomJiguan(initArr) {
        const provinces = initArr || [
            "北京",
            "天津",
            "上海",
            "重庆",
            "河北",
            "山西",
            "辽宁",
            "吉林",
            "黑龙江",
            "江苏",
            "浙江",
            "安徽",
            "福建",
            "江西",
            "山东",
            "河南",
            "湖北",
            "湖南",
            "广东",
            "海南",
            "四川",
            "贵州",
            "云南",
            "陕西",
            "甘肃",
            "青海",
            "台湾",
            "内蒙古",
            "广西",
            "西藏",
            "宁夏",
            "新疆"
        ];

        const randomIndex = Math.floor(Math.random() * provinces.length);
        return provinces[randomIndex];
    },
    getRandomPhoneNumber() {
        const firstDigit = "1";
        const secondDigitOptions = [3, 4, 5, 6, 7, 8, 9];
        const secondDigit =
            secondDigitOptions[
                Math.floor(Math.random() * secondDigitOptions.length)
            ];

        let phoneNumber = firstDigit + secondDigit;
        for (let i = 0; i < 9; i++) {
            phoneNumber += Math.floor(Math.random() * 10);
        }
        return phoneNumber;
    },
    generateUniqueTeamNames(numberOfTeams, areaList) {
        // 定义一些前缀和后缀
        const prefixes = [
            "火龙",
            "闪电",
            "飓风",
            "雄鹰",
            "猎豹",
            "猛虎",
            "狂狮",
            "飞鹰",
            "金熊",
            "银狼",
            "黑豹",
            "白鲨",
            "红魔",
            "蓝焰",
            "绿野",
            "黄蜂",
            "紫荆",
            "青云",
            "赤焰",
            "碧海",
            "星辰",
            "流星",
            "彩虹",
            "曙光",
            "夜影",
            "晨曦",
            "夕阳",
            "月光",
            "星辉",
            "晨雾",
            "晚霞",
            "雪豹",
            "冰熊",
            "火鸟",
            "雷电",
            "风神",
            "水灵",
            "山王",
            "林妖",
            "谷精",
            "石怪",
            "沙暴",
            "铁甲",
            "钢翼",
            "铜墙",
            "铁壁",
            "金盾",
            "银剑",
            "铜锤",
            "铁拳",
            "木灵",
            "土魂",
            "火灵",
            "水魂",
            "风神",
            "雷公",
            "电母",
            "火神",
            "水神",
            "风神"
        ];

        const suffixes = [
            "战士",
            "勇士",
            "斗士",
            "英雄",
            "冠军",
            "先锋",
            "飞鹰",
            "猛士",
            "巨兽",
            "闪电",
            "风暴",
            "烈焰",
            "雷霆",
            "狂风",
            "旋风",
            "飓风",
            "流星",
            "飞箭",
            "飞鹰",
            "飞豹",
            "骑士",
            "侠客",
            "武士",
            "骑士",
            "猎手",
            "射手",
            "剑客",
            "刀客",
            "枪手",
            "弓手",
            "法师",
            "术士",
            "巫师",
            "道士",
            "僧侣",
            "祭司",
            "先知",
            "预言家",
            "智者",
            "贤者",
            "勇士",
            "斗士",
            "英雄",
            "冠军",
            "先锋",
            "飞鹰",
            "猛士",
            "巨兽",
            "闪电",
            "风暴",
            "烈焰",
            "雷霆",
            "狂风",
            "旋风",
            "飓风",
            "流星",
            "飞箭",
            "飞鹰",
            "飞豹",
            "骑士",
            "侠客",
            "武士",
            "猎手",
            "射手",
            "剑客",
            "刀客",
            "枪手",
            "弓手"
        ];

        // 生成多个不重复的队名并存储在数组中
        const teamNames = [];

        while (teamNames.length < numberOfTeams) {
            const prov = this.getRandomJiguan(areaList);
            const randomPrefix = prefixes[Math.floor(Math.random() * prefixes.length)];
            const randomSuffix = suffixes[Math.floor(Math.random() * suffixes.length)];
            let newTeamName = prov + randomPrefix + randomSuffix;

            if (!teamNames.includes(newTeamName)) {
                teamNames.push(newTeamName);
            }
        }

        return teamNames;
    },
    ckCityPos: function(cityPos, region) {
        const keys = Object.keys(cityPos);
        let city;
        keys.forEach(key => {
            // 检查 str 是否以 key 开头
            if (region.startsWith(key)) {
                city = cityPos[key];
            }
        });
        return city;
    },
    numToLetter: function(num) {
        if (num < 0 || num > 25) {
            throw new Error("Number must be between 0 and 25.");
        }
        return String.fromCharCode(65 + num);
    },
    qstAnswerFmt: function(q) {
        if (q.type == 1) {
            let num = parseInt(q.answer);
            return String.fromCharCode(65 + num);
        } else if (q.type == 2) {
            let arr = JSON.parse(q.answer);
            return arr.map(n => String.fromCharCode(65 + n)).join(",");
        } else if (q.type == 3) {
            return q.answer;
        }
    },

    /**
     * 智能格式化图表数值
     * @param {number} value - 原始数值
     * @param {Object} options - 配置选项
     * @param {boolean} [options.removeZeroDecimal=true] - 是否移除小数部分的0
     * @param {number} [options.precision=2] - 最大小数位数
     * @returns {string} 格式化后的字符串
     */
    smartFormat(value, options = {}) {
        const { removeZeroDecimal = true, precision = 2 } = options;

        // 处理负值
        const sign = value < 0 ? "-" : "";
        const absValue = Math.abs(value);

        // 定义单位转换规则
        const units = [
            { threshold: 1e8, symbol: "亿", divisor: 1e8 },
            { threshold: 1e4, symbol: "万", divisor: 1e4 },
            { threshold: 1e3, symbol: "千", divisor: 1e3 }
        ];

        // 查找匹配的单位
        const matchedUnit = units.find(unit => absValue >= unit.threshold);

        if (matchedUnit) {
            const scaledValue = absValue / matchedUnit.divisor;

            // 动态确定小数位数
            let decimalPlaces = precision;
            if (scaledValue >= 100) decimalPlaces = 0;
            else if (scaledValue >= 10) decimalPlaces = 1;

            let formatted = scaledValue.toFixed(decimalPlaces);

            // 可选：移除末尾的零和小数点
            if (removeZeroDecimal) {
                // formatted = formatted.replace(/(\.0*|(?<=\.\d*?)0*)$/, "");
                formatted = formatted.replace(/\.0+$/, ""); // 1.000 → 1
                formatted = formatted.replace(/(\..*?)0+$/, "$1"); // 1.200 → 1.2
                formatted = formatted.replace(/\.$/, ""); // 123. → 123
            }

            return `${sign}${formatted}${matchedUnit.symbol}`;
        }

        // 小于最小单位直接返回原始值
        return `${sign}${absValue}`;
    },

    /**
     * 生成 ECharts yAxis 的 formatter 函数
     * @param {Object} options - 格式化选项
     * @returns {Function} 适用于 ECharts 的 formatter 函数
     */
    yAxisFormatter(options = {}) {
        return value => {
            return this.smartFormat(value, options);
        };
    },

    /**
     * 获取预配置的 yAxis 对象（可选）
     * @param {Object} options - 格式化选项
     * @returns {Object} ECharts yAxis 配置对象
     */
    getYAxisConfig(options = {}) {
        return {
            type: "value",
            axisLabel: {
                formatter: this.yAxisFormatter(options)
            }
        };
    }
};



// WEBPACK FOOTER //
// ./src/js/library.js